import { HiCloudUpload, HiTrash } from "react-icons/hi";
import "./style.scss";
import { useEffect, useState } from "react";
import Loading from "../../ui/loading/Loading";
import ImageModal from "../../../../modules/renters/components/modals/ImageModel";
import PopUpDelete from "../../layout/partials/PopupDelete";

type UploadImageFieldProps = {
  className?: string;
  src: string;
  onNewFile?: (imagePath: File) => void;
  onRemoveClick?: () => void;
  disableTrashIcon?: boolean;
  isReadOnly?: boolean;
};

const ASSETS_URL = import.meta.env.VITE_ASSETS_URL;

const buildAssetURL = (key: string) => `${ASSETS_URL}/${key}`;

export function UploadImageField(props: UploadImageFieldProps) {
  const [preview, setPreview] = useState<string>();
  const [showModal, setShowModal] = useState(false);
  const [loadingImage, setLoadingImage] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false);
  const { isReadOnly = false } = props;

  function handleFileInput(e) {
    if (isReadOnly) return;
    setLoadingImage(true);
    const reader = new FileReader();
    reader.addEventListener("load", () => setPreview(reader.result as string));
    reader.readAsDataURL(e.target.files[0]);
    props.onNewFile && props.onNewFile(e.target.files[0]);
  }

  function handleImageClick() {
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
  }

  const handlePopUpOpen = () => {
    if (isReadOnly) return;
    setShowPopup(true);
  };

  const handlePopUpConfirm = () => {
    if (isReadOnly) return;
    setPreview("");
    props.onRemoveClick && props.onRemoveClick();
    handlePopUpClose();
  };
  const handlePopUpClose = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (!props.src) {
      return;
    }

    if (!props.src.startsWith("http")) {
      setLoadingImage(false);
      setPreview(buildAssetURL(props.src));
      return;
    }

    setPreview(props.src);
  }, [props.src]);

  return (
    <div
      className={`relative box-file flex justify-center items-center rounded-md ${
        props.className || ""
      }`}
    >
      {!preview && (
        <label className="h-20 w-24 relative">
          <div className="border-2 border-dashed border-gray2 hover:border-greenPrimary flex flex-col items-center justify-center text-brown h-full">
            <HiCloudUpload className="text-3xl text-yellowPrimary/30 mt-2 absolute top-5 " />
            <span className="text-center">
              enviar <br /> arquivo
            </span>
          </div>
          <input
            alt="enviar arquivo"
            type="file"
            onChange={handleFileInput}
            disabled={isReadOnly}
            className="absolute top-0 bottom-0 left-0 right-0 opacity-0 cursor-pointer border p-2 rounded w-full"
          />
        </label>
      )}

      {loadingImage && (
        <div className="preview absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center bg-gray rounded-md">
          <Loading />
        </div>
      )}

      {preview && !loadingImage && (
        <div className="preview absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center bg-gray/50 rounded-md">
          <img src={preview} onClick={handleImageClick} />
        </div>
      )}
      {!props.disableTrashIcon && preview && !loadingImage && (
        <button
          className="absolute top-0 right-0 hover:bg-redPrimary/70 rounded-full bg-black/40 p-2 h-10 w-10 text-white flex justify-center items-center"
          type="button"
          onClick={() => handlePopUpOpen()}
        >
          <HiTrash size={24} />
        </button>
      )}

      {showModal && <ImageModal image={preview} onClose={handleCloseModal} />}
      {showPopup && (
        <PopUpDelete
          disabled={false}
          onConfirm={handlePopUpConfirm}
          onClose={handlePopUpClose}
        />
      )}
    </div>
  );
}
